import { Chrome, ChromeInputType, type ColorResult } from '@uiw/react-color';
import { useState } from 'react';

import { Button } from './ui/button';

interface ColorPickerProps {
	color: string;
	onChange: (colorObj: ColorResult) => void;
}

const ColorPicker = ({ onChange, color }: ColorPickerProps) => {
	const [isPickerVisible, setIsPickerVisible] = useState(false);
	const [selectedColor, setSelectedColor] = useState(color);

	const handleColorChange = (color: ColorResult) => {
		setSelectedColor(color.hex);
		onChange(color);
		return color;
	};
	const toggleColorPicker = () => {
		setIsPickerVisible(!isPickerVisible);
	};

	const handleClose = () => {
		setIsPickerVisible(false);
	};

	return (
		<div className="relative flex items-center">
			<div
				className="h-8 w-8 rounded-full bg-red-500 mr-2"
				style={{ backgroundColor: selectedColor }}
			/>
			<Button variant="secondary" onClick={toggleColorPicker} type="button">
				Select Color
			</Button>
			{isPickerVisible ? (
				<div className="absolute top-[calc(100%+var(--spacing-2))] left-0 z-10">
					{/* The <div> element has a child <button> element that allows keyboard interaction */}
					<div className="inset-0 fixed" onClick={handleClose} aria-hidden="true" />
					<Chrome
						showAlpha={false}
						showEyeDropper={false}
						inputType={ChromeInputType.HEXA}
						color={selectedColor}
						onChange={(color) => {
							handleColorChange(color);
						}}
					/>
				</div>
			) : null}
		</div>
	);
};

export default ColorPicker;
